import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import CryptoJS from 'crypto-js';
import { useSelector } from 'react-redux';
import { toast } from 'react-hot-toast';
import styled from 'styled-components';

import CheckImage from '../../../assets/images/check.png'
import UnCheckImage from '../../../assets/images/uncheck.png'
import BlueCheckImage from '../../../assets/images/blueCheck.png'

//API-Service
import { dimensionListService } from '../../../services/dimensionService'
import { indicatorListService } from '../../../services/indicatorService'
import { userQuestionService } from '../../../services/userQ&AService'
import { getAssesmentListService } from '../../../services/submissionService'

// Utility-Service
import { getToken, getUser } from "../../../utility/AuthService";
import Cookies from 'js-cookie'

//Custom component
import Question from '../../pages/QuestionPage'
import SubmissionEndModal from '../../components/modal/SubmissionEndModal'
import UploadedDocumentsModal from "../../components/modal/UploadedDocumentsModal";
import ShowPdfModal from "../../components/modal/ShowPdfModal";

//redux
import { selectLanguageUse } from '../../../redux/slices/language.Slice'

const TopNavigation = styled.div`
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  padding: 1.5rem;
  margin-bottom: 1rem;
  
  .dimension-tabs {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 1.5rem;
    margin-bottom: 1.5rem;
  }
  
  .dimension-tab {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 1.25rem;
    border: 1px solid #e9ecef;
    transition: all 0.2s ease;
    
    &:hover {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      transform: translateY(-1px);
    }
    
    .dimension-header {
      margin-bottom: 1rem;
      
      .dimension-title {
        font-weight: 600;
        color: #495057;
        font-size: 1.1rem;
        display: block;
        padding-bottom: 0.75rem;
        border-bottom: 2px solid #dee2e6;
        margin-bottom: 0.75rem;
      }
    }
    
    .indicator-list {
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      
      .indicator-item {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        padding: 0.75rem;
        border: none;
        background: transparent;
        border-radius: 6px;
        cursor: pointer;
        transition: all 0.2s ease;
        text-align: left;
        width: 100%;
        font-size: 0.9rem;
        
        &:hover {
          background: #e9ecef;
          transform: translateX(4px);
        }
        
        &.active {
          background: #1e3250;
          color: white;
          box-shadow: 0 2px 4px rgba(30, 50, 80, 0.3);
        }
        
        .check {
          width: 18px;
          height: 18px;
          flex-shrink: 0;
        }
        
        span {
          font-weight: 500;
          flex: 1;
        }
      }
    }
  }
  
  .upload-docs-section {
    text-align: center;
    padding-top: 1rem;
    border-top: 1px solid #e9ecef;
    
    .upload-docs-btn {
      min-width: 250px;
      padding: 0.75rem 1.5rem;
      font-weight: 500;
      border-radius: 8px;
      transition: all 0.2s ease;
      
      &:hover {
        transform: translateY(-1px);
        box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
      }
    }
  }
  
  @media (max-width: 768px) {
    .dimension-tabs {
      grid-template-columns: 1fr;
      gap: 1rem;
    }
    
    .dimension-tab {
      padding: 1rem;
    }
    
    .upload-docs-section .upload-docs-btn {
      min-width: 100%;
    }
  }
`;

function Sidebar(props) {
    const navigate = useNavigate()
    const location = useLocation()
    const [allDimension, setAllDimension] = useState([])
    const [allIndicator, setAllIndicator] = useState([])
    const [firstIndicator, setFirstIndicator] = useState([])
    const [submissionID, setSubmissionID] = useState([])
    const [limit, setLimit] = useState(10)
    const [indicatorID, setIndicatorID] = useState()
    const [currentIndicator, setCurrentIndicator] = useState([])
    const [expandDimension, setExpandDimension] = useState([])
    const [modalShow, setModalShow] = useState(false);
    const [assesmentList, setAssesmentList] = useState([]);
    const [upDocBtn, setUpDocBtn] = useState(false);
    const [submissionId, setSubmissionId] = useState()
    const [uploadedDocumentsModal, setUploadedDocumentsModal] = useState(false);
    const [pdfItem, setPdfItem] = useState();
    const [showPdfModalShow, setShowPdfModalShow] = useState(false);
    const handleModalShow = () => setModalShow(!modalShow);
    const { id } = useParams()
    const authToken = getToken()
    const user = getUser()
    const languageUse = useSelector(selectLanguageUse || user?.language)
    const viewPage = location.pathname.includes('view')
    // const currentLanguageCode = Cookies.get("i18next") || "en";

    const decryptedSubId = CryptoJS.AES.decrypt(id, 'mySecretKey').toString(CryptoJS.enc.Utf8);

    const handleShowPdfModalShow = () => setShowPdfModalShow(!showPdfModalShow);

    const UploadedDocumentsModaltoggle = (id) => {
        setSubmissionId(id)
        setUploadedDocumentsModal(!uploadedDocumentsModal)
    };

    /**
     * @function getAssesmentList
     * @param ()
     * @description get Assesment List
     */
    const getAssesmentList = async () => {
        try {
            const result = await getAssesmentListService({
                authToken,
                limit: 10,
                offset: 0
            });
            const value = result?.data?.data?.list
            setAssesmentList(value)
        } catch (error) {
            setLoading(false);
            setAssesmentList([])
            toast.error(error?.response?.data?.message || 'Something went wrong')
        }
    };

    useEffect(() => {
        getAssesmentList()
    }, []);

    /**
    * @function getQuestions
    * @param ()
    * @description handle API to get the Questions
    */
    const getQuestions = async (indicatorID, name, requiredText, requiredText_Malay) => {
        // { languageUse === 'English' ? props.setIndicatorName(requiredText) : props.setIndicatorName_Malay(requiredText) }

        console.log('getQuestions called with:', {
            indicatorID,
            name,
            requiredText,
            requiredText_Malay
        });

        props.setIndicatorName(requiredText)
        props.setIndicatorName_Malay(requiredText_Malay)

        props?.setSelectedLanguage(languageUse)
        props.setIndicator_ID(indicatorID)
        setCurrentIndicator(name)
        props.setCurrentIndicator(name)
        setIndicatorID(indicatorID)
    };

    /**
    * @function dimensionList
    * @param ()
    * @description handle API to get the dimensions
    */
    const dimensionList = async () => {
        try {
            console.log('Getting dimensions...');
            const result = await dimensionListService({
                authToken,
                filter: 'Active',
                limit: 100,
                offset: 0
            });
            
            console.log('Dimensions API response:', result?.data);
            setAllDimension(result?.data?.data?.list || []);
            
            // Debug: Log the structure of dimensions
            if (result?.data?.data?.list) {
                console.log('Dimensions loaded:', result.data.data.list.length);
                result.data.data.list.forEach((dimension, index) => {
                    console.log(`Dimension ${index + 1}:`, {
                        name: dimension.name,
                        id: dimension._id,
                        isOnSummary: dimension.isOnSummary
                    });
                });
            }
        } catch (error) {
            console.error('Error getting dimensions:', error);
            setAllDimension([]);
            toast.error(error?.response?.data?.message || 'Something went wrong');
        }
    }

    useEffect(() => {
        dimensionList()

    }, [])

    /**
        * @function getIndicator
        * @param ()
        * @description handle API to get the indicators
    */
    const getIndicator = async () => {
        try {
            console.log('Getting indicators with submissionId:', decryptedSubId);
            
            // First, get indicators for the current submission (for completion status)
            const submissionResult = await indicatorListService({
                authToken,
                filter: 'Active',
                limit: 100,
                offset: 0,
                submissionId: decryptedSubId,
            });
            
            // Then, get ALL indicators without submissionId filter (for proper progression)
            let allIndicators = [];
            try {
                const allIndicatorsResult = await indicatorListService({
                    authToken,
                    filter: 'Active',
                    limit: 100,
                    offset: 0,
                    // Remove submissionId to get all indicators
                });
                
                console.log('All indicators response:', allIndicatorsResult?.data);
                allIndicators = allIndicatorsResult?.data?.data?.list || [];
            } catch (allIndicatorsError) {
                console.warn('Failed to get all indicators, falling back to submission indicators:', allIndicatorsError);
                // Fallback: use submission indicators if getting all indicators fails
                allIndicators = submissionResult?.data?.data?.list || [];
                
                // If we're falling back, we need to ensure we have all indicators for the current dimension
                // This is a workaround for the API issue
                console.log('Using fallback indicators, ensuring complete dimension coverage');
                
                // Since the API call without submissionId is failing, we need to work with what we have
                // The submission indicators should contain all the indicators we need for progression
                console.log('Working with submission indicators for progression');
            }
            
            console.log('Submission indicators response:', submissionResult?.data);
            
            // Merge the data: use all indicators but preserve completion status from submission
            const submissionIndicators = submissionResult?.data?.data?.list || [];
            
            // Create a map of completion status by indicator ID
            const completionMap = {};
            submissionIndicators.forEach(indicator => {
                completionMap[indicator._id] = indicator.isCompleted;
            });
            
            // Merge indicators with completion status
            const mergedIndicators = allIndicators.map(indicator => ({
                ...indicator,
                isCompleted: completionMap[indicator._id] || 'false'
            }));
            
            // Ensure we have complete dimension coverage by checking if all dimensions have their indicators
            const dimensionCoverage = {};
            allDimension.forEach(dimension => {
                const dimensionIndicators = mergedIndicators.filter(indicator => 
                    indicator.dimension?._id === dimension._id
                );
                dimensionCoverage[dimension._id] = dimensionIndicators.length;
                console.log(`Dimension ${dimension.name}: ${dimensionIndicators.length} indicators`);
            });
            
            console.log('Dimension coverage:', dimensionCoverage);
            
            setAllIndicator(mergedIndicators);
            setFirstIndicator(mergedIndicators.filter(item_Indi => item_Indi.dimension?._id === allDimension[0]?._id));
            
            // Debug: Log the structure of indicators
            if (mergedIndicators.length > 0) {
                console.log('Merged indicators loaded:', mergedIndicators.length);
                mergedIndicators.forEach((indicator, index) => {
                    console.log(`Indicator ${index + 1}:`, {
                        name: indicator.name,
                        dimension: indicator.dimension?.name,
                        dimensionId: indicator.dimension?._id,
                        isCompleted: indicator.isCompleted
                    });
                });
            }
        } catch (error) {
            console.error('Error getting indicators:', error);
            setAllIndicator([]);
            setFirstIndicator([]);
            toast.error(error?.response?.data?.message || 'Something went wrong');
        }
    };

    useEffect(() => {
        getIndicator()

    }, [props.changeIndicatorName, allDimension]);


    useEffect(() => {

        if (indicatorID) {
            const currentIndicatorIndex = allIndicator?.findIndex(item => item._id === indicatorID);
            
            // Get the current indicator's dimension
            const currentIndicator = allIndicator[currentIndicatorIndex];
            const currentDimensionId = currentIndicator?.dimension?._id;
            
            // Get all indicators in the current dimension
            const currentDimensionIndicators = allIndicator?.filter(item => item.dimension?._id === currentDimensionId);
            
            console.log('Progression Debug:', {
                currentIndicator: currentIndicator?.name,
                currentDimensionId,
                currentDimensionIndicators: currentDimensionIndicators?.map(i => i.name),
                currentIndicatorPosition: currentDimensionIndicators?.findIndex(item => item._id === indicatorID),
                totalIndicatorsInDimension: currentDimensionIndicators?.length,
                allIndicatorsCount: allIndicator?.length,
                currentDimensionName: allDimension?.find(d => d._id === currentDimensionId)?.name
            });
            
            // Check if we're at the last indicator of the current dimension
            const isLastIndicatorInDimension = currentDimensionIndicators?.findIndex(item => item._id === indicatorID) === currentDimensionIndicators.length - 1;
            
            console.log('Progression decision:', {
                isLastIndicatorInDimension,
                currentIndicatorPosition: currentDimensionIndicators?.findIndex(item => item._id === indicatorID),
                totalInDimension: currentDimensionIndicators?.length
            });
            
            if (isLastIndicatorInDimension) {
                // Move to next dimension
                const currentDimensionIndex = allDimension?.findIndex(item => item._id === currentDimensionId);
                const nextDimensionIndex = currentDimensionIndex + 1;
                
                if (nextDimensionIndex < allDimension?.length) {
                    const nextDimension = allDimension[nextDimensionIndex];
                    
                    // Expand the next dimension in the sidebar
                    if (expandDimension?.length > 0 && !expandDimension?.includes(nextDimension?._id)) {
                        const temp = [...expandDimension, nextDimension?._id];
                        setExpandDimension(temp);
                    }
                    
                    // Get the first indicator of the next dimension
                    const nextDimensionIndicators = allIndicator?.filter(item => item.dimension?._id === nextDimension?._id);
                    const firstNextDimensionIndicator = nextDimensionIndicators[0];
                    
                    if (firstNextDimensionIndicator) {
                        console.log('Moving to next dimension:', nextDimension.name, 'First indicator:', firstNextDimensionIndicator.name);
                        getQuestions(
                            firstNextDimensionIndicator._id, 
                            firstNextDimensionIndicator.name, 
                            firstNextDimensionIndicator.requiredText, 
                            firstNextDimensionIndicator.requiredText_Malay
                        );
                    } else {
                        console.error('No indicators found for next dimension:', nextDimension.name);
                    }
                } else {
                    console.log('No more dimensions available');
                }
            } else {
                // Move to next indicator within the same dimension
                // Find the next indicator in the same dimension, not just the next in the array
                const currentIndicatorPosition = currentDimensionIndicators?.findIndex(item => item._id === indicatorID);
                const nextIndicatorInDimension = currentDimensionIndicators[currentIndicatorPosition + 1];
                
                if (nextIndicatorInDimension) {
                    console.log('Moving to next indicator in same dimension:', nextIndicatorInDimension.name);
                    getQuestions(
                        nextIndicatorInDimension._id, 
                        nextIndicatorInDimension.name, 
                        nextIndicatorInDimension.requiredText, 
                        nextIndicatorInDimension.requiredText_Malay
                    );
                } else {
                    console.log('No more indicators in current dimension, moving to next dimension');
                    // Fallback: if we can't find the next indicator in the same dimension, move to next dimension
                    const currentDimensionIndex = allDimension?.findIndex(item => item._id === currentDimensionId);
                    const nextDimensionIndex = currentDimensionIndex + 1;
                    
                    if (nextDimensionIndex < allDimension?.length) {
                        const nextDimension = allDimension[nextDimensionIndex];
                        const nextDimensionIndicators = allIndicator?.filter(item => item.dimension?._id === nextDimension?._id);
                        const firstNextDimensionIndicator = nextDimensionIndicators[0];
                        
                        if (firstNextDimensionIndicator) {
                            console.log('Fallback: Moving to next dimension:', nextDimension.name, 'First indicator:', firstNextDimensionIndicator.name);
                            getQuestions(
                                firstNextDimensionIndicator._id, 
                                firstNextDimensionIndicator.name, 
                                firstNextDimensionIndicator.requiredText, 
                                firstNextDimensionIndicator.requiredText_Malay
                            );
                        }
                    }
                }
            }
        }
    }, [props.changeIndicatorName]);

    useEffect(() => {
        if (allDimension?.length > 0) {

            const filteredDimension = allDimension.map(item => {
                if (item.isOnSummary) {
                    return item._id
                }
            }).filter(item => item !== undefined)

            if (allIndicator?.length > 0) {
                const filteredIndicator = allIndicator.filter(item => filteredDimension.includes(item.dimension._id))

                if (filteredIndicator?.length > 0 && Object.values(filteredIndicator).every(item => item?.isCompleted === 'true') && assesmentList?.length > 0 && assesmentList?.find(item => item?._id === decryptedSubId)?.isDraft) {
                    if (!viewPage) {
                        setModalShow(true)
                    }
                    // navigate(`/uploadDocuments/${decryptedSubId}`)
                    setUpDocBtn(true)
                }
            }
        }
    }, [allDimension, allIndicator]);

    return (
        <TopNavigation>
            <>
                {allDimension?.length > 0 ? <>
                    <div className="dimension-tabs">
                        {allDimension?.length > 0 && allDimension?.map((item, index) => (
                            <div key={item._id} className="dimension-tab">
                                <div className="dimension-header">
                                    <span className="dimension-title">{languageUse === 'English' ? item.name : item.name_Malay}</span>
                                </div>
                                <div className="indicator-list">
                                    {allIndicator?.length > 0 && allIndicator?.filter(item_Indi => item_Indi.dimension?._id === item._id).map((item_Indi, index_Indi) => (
                                        <button 
                                            key={item_Indi._id} 
                                            className={`indicator-item ${currentIndicator === item_Indi.name ? 'active' : ''}`}
                                            onClick={() => getQuestions(item_Indi._id, item_Indi.name, item_Indi.requiredText, item_Indi.requiredText_Malay)}
                                        >
                                            <img src={(item.name === 'Demographic' && item.isOnSummary) ? CheckImage : item_Indi.isCompleted === 'true' ? CheckImage : currentIndicator === item_Indi.name ? BlueCheckImage : UnCheckImage} className="check" />
                                            <span>{languageUse === 'English' ? item_Indi.name : item_Indi.name_Malay}</span>
                                        </button>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                    
                    <div className="upload-docs-section">
                        {!viewPage && <button className='btn btn-outline-primary upload-docs-btn' onClick={() => {
                            if (upDocBtn) {
                                navigate(`/uploadDocuments/${decryptedSubId}`)
                            } else {
                                toast.dismiss();
                                toast.error(languageUse === 'English' ? 'You must complete all questions in all sections before uploading documents. Use the navigation menu to ensure every section is answered.' : 'Vous devez répondre à toutes les questions dans toutes les sections avant de télécharger des documents. Utilisez le menu de navigation pour vérifier que chaque section est complétée.');
                            }
                        }}>{languageUse === 'English' ? 'Upload Supporting Documents' : 'Muatnaik dokumen sokongan'}</button>}

                        {viewPage && <button className='btn btn-outline-primary upload-docs-btn' onClick={() => UploadedDocumentsModaltoggle(decryptedSubId)}>{languageUse === 'English' ? 'Upload Supporting Documents' : 'Muatnaik dokumen sokongan'}</button>}
                        

                    </div>
                </> : <></>}
                <SubmissionEndModal show={modalShow} handleClose={handleModalShow} submission_id={decryptedSubId} questionPage={true} decryptedSubId={decryptedSubId} />

                <UploadedDocumentsModal modal={uploadedDocumentsModal} toggle={UploadedDocumentsModaltoggle} handleShowPdfModalShow={handleShowPdfModalShow} submissionId={submissionId} setPdfItem={setPdfItem} />
                <ShowPdfModal show={showPdfModalShow} handleClose={handleShowPdfModalShow} pdfItem={pdfItem} />
            </>

        </TopNavigation>

    )
};

export default Sidebar